
<div  *ngIf="toastMessage" class="alert {{iconClass?.[toastMessage?.type]}} ">
    <div class="image-icon"></div>
    <div class="content">
      <h2>{{toastMessage?.title}}</h2>
      <p>
        {{toastMessage?.message}}
      </p>
    </div>
      <div class="btn-section-close" (click)="makeToastEmpty(toastMessage);">
        <span></span>
        </div>
  </div>

